// "Michael Ricci" -> "MR"; falls back to the email's local part; "" -> "?"
const getInitials = (name?: string | null, email?: string | null) => {
  const source = name && !name.includes('@') ? name : email || '';
  const parts = source
    .split('@')[0]
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  return parts
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
};

export default getInitials;
